import { SectionHead, TextField, TextareaField } from "@/components/inquiry/inquiryFields";

/**
 * StepVision — project goals + high-level vision. Requires at least
 * `goals` OR `project_details` (validated by inquiryState.validateStep).
 */
export const StepVision = ({ data, onField, errors }) => (
    <section data-testid="step-vision">
        <SectionHead
            eyebrow="Step 05 · Vision"
            title="Where do you want to go?"
            description="Share the vision — audience, positioning, references. Even a few sentences help us reply with a sharper proposal."
        />

        <div className="space-y-5">
            <TextareaField
                id="vision-goals"
                label="Your Goals"
                value={data.goals}
                onChange={(e) => onField("goals", e.target.value)}
                placeholder="e.g. Reposition as a premium editorial brand aimed at Gen-Z creatives."
                testId="vision-goals-input"
                hint="What outcome would make this project a win?"
            />
            <TextField
                id="vision-need"
                label="What do you need?"
                value={data.what_do_you_need}
                onChange={(e) => onField("what_do_you_need", e.target.value)}
                placeholder="e.g. Logo system + guidelines + social kit"
                testId="vision-need-input"
            />
            <TextareaField
                id="vision-details"
                label="Project Details"
                value={data.project_details}
                onChange={(e) => onField("project_details", e.target.value)}
                placeholder="Share references, style influences, competitors, tone, and anything else that helps."
                testId="vision-details-input"
                hint="The more you share, the sharper our first proposal will be."
            />
        </div>

        {errors?._step && (
            <p className="mt-4 text-[13px]" style={{ color: "#FF6B6B" }} data-testid="vision-step-error">
                {errors._step}
            </p>
        )}
    </section>
);

export default StepVision;
